import * as React from 'react';
import * as styles from './styles.scss';
import { ControlIcons } from 'owa-control-icons';
import { emptyBucketDragHintText } from '../bucketStrings.locstring.json';
import { Icon } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';
import { ORDER_MAX } from 'owa-timestream-asset-sdk-bucket';
import BucketDropTarget from './BucketDropTarget';
import loc from 'owa-localize';

export default observer(function EmptyBucketDropTarget() {
    return (
        <BucketDropTarget
            inactiveClassName={styles.emptyBucketDropTargetInactive}
            activeClassName={styles.emptyBucketDropTargetInactive}
            hoverClassName={styles.emptyBucketDropTargetHover}
            minOrder={-ORDER_MAX}
            maxOrder={ORDER_MAX}>
            <Icon className={styles.dragAssetsHintIcon} iconName={ControlIcons.Stack} />
            <span className={styles.dragAssetsHintText}>{loc(emptyBucketDragHintText)}</span>
        </BucketDropTarget>
    );
});
